import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import __ from "src/utils/Translations";

const AnchorTag = ({ href, to, id, isTargetBlank, children }) =>
  href ? (
    <a
      href={href}
      className="link-unstyled"
      data-t1={`${id}Tile`}
      target={isTargetBlank ? "_blank" : "_self"}
      rel={isTargetBlank ? "noreferrer noopener" : undefined}
    >
      {children}
    </a>
  ) : (
    <Link to={to} className="link-unstyled" data-t1={`${id}Tile`}>
      {children}
    </Link>
  );

AnchorTag.propTypes = {
  href: PropTypes.string,
  to: PropTypes.string,
  id: PropTypes.string.isRequired,
  isTargetBlank: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

AnchorTag.defaultProps = {
  href: "",
  to: "",
  isTargetBlank: false,
};

export default AnchorTag;
